




import { defineComponent, onMounted } from '@vue/composition-api';
import { useRouter } from 'vivat';

import { onLogout, client } from '@/useApollo';

const Logout = defineComponent({
  setup() {
    const { router } = useRouter();

    onMounted(async () => {
      onLogout(client);
      router.push({ name: 'Login' });
    });
  },
});

export default Logout;
